import dayjs from 'dayjs';
import { DateFormat } from '@cp/src/utils/DateHelper';
import styles from './index.module.scss';
import InputDataContainer from './InputDataContainer';
import cx from 'classnames';
import TickBoxIcon from '@cp/src/assets/icons/TickBoxIcon';
import CrossBoxIcon from '@cp/src/assets/icons/CrossBoxIcon';
import { MockAllocationDetails } from '../../../interface';

const ProcessingDetails = ({
  showInputProcessingDetails = false,
  allocationDetails
}: {
  showInputProcessingDetails?: boolean;
  allocationDetails: MockAllocationDetails | null;
}) => {
  const agencyCapping = allocationDetails?.agencyCappingIncluded || false;
  const mockApprovedBy = allocationDetails?.mockAllocationApprovedBy;
  const inputPreparationDetails = allocationDetails?.inputPreparationData;
  const mockAllocationDetails = allocationDetails?.mockAllocationData;
  const details = showInputProcessingDetails ? inputPreparationDetails : mockAllocationDetails;

  const processingDetails = [
    {
      label: 'Processed by',
      value: details?.initiatedBy || '-',
      format: 'string',
      showOnlyIf: !!details?.initiatedBy
    },
    {
      label: 'Agency capping',
      value: agencyCapping,
      format: 'boolean',
      showOnlyIf: !showInputProcessingDetails
    },
    {
      label: 'Started at',
      value: details?.initiatedAt || '-',
      format: 'date',
      showOnlyIf: !!details?.initiatedAt
    },
    {
      label: 'Finished at',
      value: details?.completedAt || '-',
      format: 'date',
      showOnlyIf: !!details?.completedAt
    },
    {
      label: 'Approved by',
      value: mockApprovedBy || '-',
      format: 'string',
      showOnlyIf: !!mockApprovedBy && !showInputProcessingDetails
    }
  ];

  if (!processingDetails?.length) return null;

  const formatValue = (value: string | boolean | number, format?: string) => {
    if (format === 'date') {
      return dayjs.unix(value as number).format(DateFormat.DD_MMM_hh_mm_A);
    }
    if (format === 'boolean') {
      return value ? 'Included' : 'Excluded';
    }
    return String(value);
  };

  return (
    <div className="flex flex-row items-end">
      {processingDetails.map((detail, index) => {
        if (!detail?.showOnlyIf) return null;

        return (
          <div
            key={detail?.label}
            className={cx(styles.dataContainer, index === 0 ? '' : styles.borderStyle)}
          >
            <InputDataContainer
              leftLabel={detail?.label}
              rightLabel={formatValue(detail?.value, detail?.format)}
              icon={
                detail?.format === 'boolean' ? (
                  detail?.value ? (
                    <TickBoxIcon />
                  ) : (
                    <CrossBoxIcon />
                  )
                ) : null
              }
            />
          </div>
        );
      })}
    </div>
  );
};

export default ProcessingDetails;
